module.exports = __webpack_public_path__ + "assets/img/plain.e0fd0ea1.png";